import moment, { Moment } from 'moment'
import React, { useState } from 'react'

import globalNotification from 'live/services/global-notification'
import i18n from 'live/services/i18n'

import { Scrollbars, TimeSpan } from 'plugin-generic-components/shared/components/components'

import { Presets } from './components'
import { CancelButton, SaveBar, SaveButton, SidebarContainer } from './styles'
import { isNullOrUndefined } from 'plugin-codaf-risk-ext-bowtie/utils'

interface IProps {
    presetActive: string
    setPresetActive: (k: string) => void
    setPreset: (k: string | null) => void
    setTime: (k: string | null) => void
    setStartDay: (k: string | null) => void
    setEndDay: (k: string | null) => void
    setStartHour: (k: string | null) => void
    setEndHour: (k: string | null) => void
    startDay: string | null
    endDay: string | null
    startHour: string | null
    endHour: string | null
    time: string | null
}

export const Sidebar: React.FC<IProps> = ({
    presetActive,
    setPresetActive,
    setPreset,
    setTime,
    setStartDay,
    setStartHour,
    setEndDay,
    setEndHour,
    startDay,
    startHour,
    endDay,
    endHour,
    time
}) => {
    const [startDate, setStartDate] = useState<Moment>()
    const [endDate, setEndDate] = useState<Moment>()
    const [collapse, setCollapse] = useState(false)

    const onCollapse = (): void => {
        setCollapse(!collapse)
    }

    const onDateValidation = (): void => {
        if (isNullOrUndefined(presetActive)) {
            return globalNotification.error('Report type must be selected')
        }
        if (moment(startDate).isAfter(endDate)) {
            return globalNotification.error('End date must be greater than the start date.')
        }

        if (!moment(startDate).isValid || !moment(endDate).isValid) {
            return globalNotification.error(
                'Invalid date. Please follow the YYYY/MM/DD pattern for dates and hh:mm for time.'
            )
        }

        setStartDay((startDate as Moment).format('YYYY/MM/DD').toString())
        setStartHour((startDate as Moment).format('HH:mm').toString())
        setEndDay((endDate as Moment).format('YYYY/MM/DD').toString())
        setEndHour((endDate as Moment).format('HH:mm').toString())
        setPreset(presetActive)
    }

    const onClear = (): void => {
        setStartDay(null)
        setStartHour(null)
        setEndDay(null)
        setEndHour(null)
        setStartDate(null)
        setEndDate(null)
        setPreset(null)
        setPresetActive(null)
    }

    return (
        <SidebarContainer collapse={collapse}>
            <div className={'topSettings ' + collapse}>
                <div className={'TitleSidebarOn ' + collapse}>{i18n('SETTINGS')}</div>
                <div className={'TitleSidebarOff ' + collapse}>
                    <div className={'divtema ' + collapse}>{i18n('SETTINGS')}</div>
                </div>
                <button onClick={onCollapse}>
                    {collapse ? <i className="fas fa-chevron-right"></i> : <i className="fas fa-chevron-left"></i>}
                </button>
            </div>
            <Scrollbars className={'sidebar-reports-scrollbar ' + collapse}>
                <Presets setPreset={setPresetActive} />
                <TimeSpan startDate={startDate} endDate={endDate} setEndDate={setEndDate} setStartDate={setStartDate} />
                <SaveBar>
                    <SaveButton
                        disabled={!startDate || !endDate || isNullOrUndefined(presetActive)}
                        className={`btn-lg btn-bold save ${
                            !startDate || !endDate || isNullOrUndefined(presetActive) ? 'disabled' : ''
                        }`}
                        onClick={onDateValidation}
                    >
                        {i18n('Apply')}
                    </SaveButton>
                    <CancelButton className="btn-lg btn-bold cancel" type="button" onClick={onClear}>
                        {i18n('Clear')}
                    </CancelButton>
                </SaveBar>
            </Scrollbars>
        </SidebarContainer>
    )
}
